import React, { useMemo } from 'react';

import { SummaryFieldTitle, SummaryFieldValue } from '../shared/styled';
import { useDiscountWizardStateContext } from '../state';
import { ApplicationMethodTypeId } from '../types/index';

const applicationMethodsWithExternalIdField = [
  ApplicationMethodTypeId.ByAlpineIQ,
  ApplicationMethodTypeId.BySpringBig,
  ApplicationMethodTypeId.ExternalLoyalty,
];

export function ExternalId() {
  const {
    configureStepState: { applicationMethod, externalId },
  } = useDiscountWizardStateContext();
  const label = useMemo(() => getLabel(applicationMethod), [applicationMethod]);

  const showField = useMemo(
    () => applicationMethodsWithExternalIdField.includes(applicationMethod) && externalId !== '',
    [applicationMethod, externalId]
  );

  return (
    <>
      {showField && (
        <>
          <SummaryFieldTitle>{label}</SummaryFieldTitle>
          <SummaryFieldValue>{externalId}</SummaryFieldValue>
        </>
      )}
      {!showField && null}
    </>
  );
}

function getLabel(applicationMethod: ApplicationMethodTypeId) {
  switch (applicationMethod) {
    case ApplicationMethodTypeId.ByAlpineIQ:
      return 'Alpine IQ discount ID:';
    case ApplicationMethodTypeId.BySpringBig:
      return 'SpringBig discount ID:';
    default:
      return 'External ID:';
  }
}
